

 
 <div class="page-container">
  <div class="content-wrap">

<!-- Navigation 85px-->
<nav class="navbar navbar-expand-lg static-top" style="background-color: #0079c1; height:50px;">
  <div class="container-fluid">



    <div class="d-inline p-1 text-white"> {{'applicationwizard.TranslationSection.text1' | translate}}  &nbsp;&nbsp;<label style="color: white; font-size: large;"><b>{{User}}</b></label>
    </div>
<div class="d-inline p-2  text-white"><a class="nav-link" [routerLink]="['/login']" (click)="logout()" value="Log Out" style="color: white; font-size: medium;">{{'applicationwizard.TranslationSection.text2' | translate}}</a></div>

  

    
    
  </div>
</nav>



<!-- Page Content -->
<div class="container-fluid" >


  
  <div class="row">
    
    <div class="col-lg-12 col-sm-12 col-md-12">



  <div id="registration" class="container-fluid col-lg-10 col-sm-10 col-md-10">


    <div *ngIf="('1' === '1') then wizardTemplate"></div>
    
<ng-template #wizardTemplate>

  <div style="text-align:center">
    <br>
      
  

    <h1> <div style="font-family: Verdana, Geneva, sans-serif; font-weight: bold; font-size: 30px;">{{'applicationwizard.TranslationSection.text3' | translate}}</div></h1>
    <h3> <div style="font-family: Verdana, Geneva, sans-serif; font-size: 20px;">{{'applicationwizard.TranslationSection.text4' | translate}}</div></h3>
 
    
      </div>

      <div class="row" style="height: 20px;" *ngIf="isDesktop"></div>

      <div *ngIf="!isDesktop">
      <div class="row" style="height: 50px;"></div>
      <div style="text-align:center">
     <label style="font-size: x-large;">Page</label> <label style="font-size: x-large;" class="notranslate"><b>{{this.pagenumber}}</b></label> <label style="font-size: x-large;" >of</label> <label style="font-size: x-large;" class="notranslate"><b>{{this.totalpage}}</b></label>
      </div>
<div class="row" style="height: 50px;"></div>
</div>

<!--<label style="font-size: x-large;">Page {{pagenumber}} of {{totalpage}}</label>-->
      <!--General -->
      <!--Welcome -->
      <!--Contact -->
      <!--Education-->
      <!--Credentials -->
      <!--Eligibility -->
      <!--Availability -->
      <!--Specialty -->
      <!--Work History -->
      <!--References -->
      <!--Additional Questions -->

<!--events (continueevnt) allows us to pass data from child to parent and input properties [regForm] allows us to pass data from parent to child-->
      <mat-horizontal-stepper #stepper linear> <!--(selectionChange)="onStepChange($event)"-->

 <mat-step *ngIf="generalForm  && this.wizsteps && this.wizsteps[0].IncludePage"  [completed]="isCompleted[0]">
         <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text5' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text5' | translate}}</label></ng-template> <!--General-->
      
          <app-wizardpage-step1-general  [regForm]="appgeneralForm.get('generalPage')"  (pagecountevnt)="pageCountNavigation($event)" (continueevnt)="submitGeneralPage($event)"  (wizardeevnt)="getWizardSteps($event)"></app-wizardpage-step1-general>
    </mat-step>


    <mat-step *ngIf="generalForm && this.wizsteps && this.wizsteps[1].IncludePage" [completed]="isCompleted[1]">
          <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text6' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text6' | translate}}</label></ng-template> <!--Welcome-->
          <app-wizardpage-step2-welcome  (continueevnt)="submitWelcome($event,true)" (pagecountevnt)="pageCountNavigation($event)" ></app-wizardpage-step2-welcome>
      </mat-step> 
      

      <mat-step *ngIf="generalForm && this.wizsteps && this.wizsteps[2].IncludePage" [completed]="isCompleted[2]">
        <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text7' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text7' | translate}}</label></ng-template> <!--Contact-->
        <app-wizardpage-step3-contact  [regForm]="appgeneralForm.get('contactPage')" (continueevnt)="submitContact($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step3-contact>
    </mat-step> 
    
    <mat-step *ngIf="generalForm && this.wizsteps && this.wizsteps[3].IncludePage" [completed]="isCompleted[3]">
      <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text8' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text8' | translate}}</label></ng-template> <!--Education-->
      <app-wizardpage-step4-education [regForm]="appeducationForm"  (continueevnt)="submitEducation($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step4-education>
  </mat-step> 
  
  <mat-step *ngIf="generalForm && this.wizsteps && this.wizsteps[4].IncludePage" [completed]="isCompleted[4]">
    <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text9' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text9' | translate}}</label></ng-template> <!--Credentials-->
    <app-wizardpage-step5-credentials   [regForm]="appgeneralForm.get('credentialsPage')"  (continueevnt)="submitCredentials($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step5-credentials>
</mat-step>


  
<mat-step *ngIf="generalForm && this.wizsteps && this.wizsteps[5].IncludePage" [completed]="isCompleted[5]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text10' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text10' | translate}}</label></ng-template> <!--Eligibility-->
  <app-wizardpage-step6-eligibility  [regForm]="appgeneralForm.get('eligibilityPage')"  (continueevnt)="submitEligibility($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step6-eligibility>
</mat-step>  


<mat-step *ngIf="generalForm && this.wizsteps &&  this.wizsteps[6].IncludePage" [completed]="isCompleted[6]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text11' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text11' | translate}}</label></ng-template> <!--Availability-->
  <app-wizardpage-step7-availability [regForm]="appgeneralForm.get('availabilityPage')"  (continueevnt)="submitAvailability($event,true)" (pagecountevnt)="pageCountNavigation($event)" ></app-wizardpage-step7-availability>
</mat-step> 


<!-- Changes Md (SpecialtyPage) 08/02/2022
<mat-step *ngIf="generalForm && this.wizsteps &&  this.wizsteps[7].IncludePage" [completed]="isCompleted[7]">
  <ng-template matStepLabel><label *ngIf="isDesktop">Specialty</label> <label style="font-size: x-small;" *ngIf="!isDesktop">Specialty</label></ng-template>
  <app-wizardpage-step8-specialty [regForm]="appgeneralForm.get('specialtyPage')"  (continueevnt)="submitSpecialty($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step8-specialty>
</mat-step>
-->

<mat-step *ngIf="appworkhistoryForm && this.wizsteps &&  this.wizsteps[8].IncludePage" [completed]="isCompleted[8]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text12' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text12' | translate}}</label></ng-template> <!--Work History-->
  <app-wizardpage-step9-workhistory [regForm]="appworkhistoryForm"  (continueevnt)="submitWorkHistory($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step9-workhistory>
</mat-step> 

<!-- Changes Md (References) 08/02/2022
<mat-step *ngIf="appreferencesForm && this.wizsteps &&  this.wizsteps[9].IncludePage" [completed]="isCompleted[9]">
  <ng-template matStepLabel><label *ngIf="isDesktop">References</label> <label style="font-size: x-small;" *ngIf="!isDesktop">References</label></ng-template>
  <app-wizardpage-step10-references [regForm]="appreferencesForm"  (continueevnt)="submitReferences($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step10-references>
</mat-step> 
-->


<mat-step *ngIf="generalForm && this.wizsteps &&  this.wizsteps[10].IncludePage" [completed]="isCompleted[10]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text13' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text13' | translate}}</label></ng-template> <!--Additional Questions-->
  <app-wizardpage-step11-additionalquestions [regForm]="appgeneralForm.get('additionalQuestPage')"  (continueevnt)="submitAddQuestions($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step11-additionalquestions>
</mat-step> 

<!-- Remove exam Md 08/03/2022
<mat-step *ngIf="appbasicexamForm && this.wizsteps &&  this.wizsteps[11].IncludePage" [completed]="isCompleted[11]">
  <ng-template matStepLabel><label *ngIf="isDesktop">Basic Exam </label> <label style="font-size: x-small;" *ngIf="!isDesktop">Basic Exam </label></ng-template>
  <app-wizardpage-step12-basicexam [regForm]="appbasicexamForm"  (continueevnt)="submitExams($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step12-basicexam>
</mat-step>

<mat-step *ngIf="apppcaexamForm && this.wizsteps &&  this.wizsteps[12].IncludePage" [completed]="isCompleted[12]">
  <ng-template matStepLabel><label *ngIf="isDesktop">PCA Exam</label> <label style="font-size: x-small;" *ngIf="!isDesktop">PCA Exam</label></ng-template>
  <app-wizardpage-step13-pcaexam [regForm]="apppcaexamForm"  (continueevnt)="submitExams($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step13-pcaexam>
</mat-step> 

<mat-step *ngIf="appcertexamForm && this.wizsteps &&  this.wizsteps[13].IncludePage" [completed]="isCompleted[13]">
  <ng-template matStepLabel><label *ngIf="isDesktop">Certified Exam</label> <label style="font-size: x-small;" *ngIf="!isDesktop">Certified Exam</label></ng-template>
  <app-wizardpage-step14-certifiedexam [regForm]="appcertexamForm"  (continueevnt)="submitExams($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step14-certifiedexam>
</mat-step> 

<mat-step *ngIf="apppharmexamForm && this.wizsteps &&  this.wizsteps[14].IncludePage" [completed]="isCompleted[14]">
  <ng-template matStepLabel><label *ngIf="isDesktop">Pharmacology Exam</label> <label style="font-size: x-small;" *ngIf="!isDesktop">Pharmacology Exam</label></ng-template>
  <app-wizardpage-step16-pharmexam [regForm]="apppharmexamForm"  (continueevnt)="submitExams($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step16-pharmexam>
</mat-step> 

<mat-step *ngIf="apphomecareexamForm && this.wizsteps &&  this.wizsteps[15].IncludePage" [completed]="isCompleted[15]"> 
  <ng-template matStepLabel><label *ngIf="isDesktop">Home Care Aide Exam</label> <label style="font-size: x-small;" *ngIf="!isDesktop">Home Care Aide Exam</label></ng-template>
  <app-wizardpage-step15-hcaexam [regForm]="apphomecareexamForm"  (continueevnt)="submitExams($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step15-hcaexam>
</mat-step>
-->

<!-- end exam -->


<mat-step *ngIf="generalForm && this.wizsteps &&  this.wizsteps[16].IncludePage" [completed]="isCompleted[16]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text14' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text14' | translate}}</label></ng-template> <!-- Terms of Use -->
  <app-wizardpage-step17-terms [regForm]="appgeneralForm.get('termsPage')"  (continueevnt)="submitTerms($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step17-terms>
</mat-step> 

<mat-step *ngIf="generalForm && this.wizsteps &&  this.wizsteps[17].IncludePage"  [completed]="isCompleted[17]">
  <ng-template matStepLabel><label *ngIf="isDesktop">{{'applicationwizard.TranslationSection.text15' | translate}}</label> <label style="font-size: x-small;" *ngIf="!isDesktop">{{'applicationwizard.TranslationSection.text15' | translate}} </label></ng-template><!--Review -->
  <app-wizardpage-step18-review [regForm]="appgeneralForm.get('generalPage')" [conForm]="appgeneralForm.get('contactPage')" (continueevnt)="submitApplication($event,true)" (pagecountevnt)="pageCountNavigation($event)"></app-wizardpage-step18-review>
</mat-step> 
  
      </mat-horizontal-stepper>
</ng-template>

   <!--</form>-->
  </div>

</div>
</div>




<div class="row" style="height:25px;"></div>


<div class="row" >

  
  <footer class="homefooter" >
    <p>{{'applicationwizard.TranslationSection.text16' | translate}}</p>
    </footer>

</div>

</div>

</div>


</div>


